import api from 'service/api'

const marketPlaceAPI = api.create('marketPlace', false)

const list = async (params) => {
  const response = await marketPlaceAPI.get('/addresses', { params })

  return response
}

const create = async (params) => {
  return await marketPlaceAPI.post('/addresses', params)
}

const update = async (id, params) => {
  return await marketPlaceAPI.put(`/addresses/${id}`, params)
}

const destroy = async (id) => {
  return await marketPlaceAPI.delete(`/addresses/${id}`)
}

const address = {
  list,
  create,
  update,
  destroy,
}

export default address
